<template>
    <div container-table>
        <header>
            <h1 class="d-flex justify-content-center">Projects</h1>
        </header>
        <div class="py-1">
            <div class="container-form">
                <div class="add-btn d-flex justify-content-between">
                    <button style="margin-bottom:5px;" @click="toggleArchived" class="btn btn-primary">
                        {{ archiveFilter ? 'Show All' : 'Hide Archived' }}
                    </button>
                    <button style="margin-bottom:5px;" @click="$router.push({ path: 'projects/edit' })" class="btn btn-primary">Add</button>
                </div>
                <div class="table-content">
                    <div class="d-flex justify-content-center">
                        <ag-grid-vue style="width: 1100px; height: 700px;"
                                        class="ag-theme-balham"
                                        :gridOptions="gridOptions"
                                        :columnDefs="columnDefs"
                                        :rowData="rowData"
                                        rowSelection='single'
                                        domLayout='autoHeight'
                                        @grid-ready="onGridReady"
                                        @first-data-rendered="onFirstDataRendered">
                        </ag-grid-vue>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">

    .add-btn {
    }
    /* Works on Chrome, Edge, and Safari */

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background-color: rgba(155, 155, 155, 0.5);
        border-radius: 20px;
        border: transparent;
    }

    body {
        overflow: hidden;
    }


</style>

<script>
    // @ is an alias to /src
    import { AgGridVue } from "ag-grid-vue";
    import axios from 'axios'

    export default {
        name: 'projects',
        components: {
            AgGridVue
        },
        data: function () {
            return {
                info: null,
                loading: true,
                errored: false,
                columnDefs: null,
                gridOptions: null,
                rowData: null,
                gridApi: null,
                archivedFilterModel: {
                    archived: {
                        type: 'equals',
                        filter: 'false'
                    }
                },
                archiveFilter: true

            }
        },
        beforeMount() {
            this.gridOptions = {
                defaultColDef: {
                    filter: true, // set filtering on for all cols
                    sortable: true,
                    cellClass: "cell-wrap-text",
                    autoHeight: true,
                    resizable: true,
                    flex: 1,
                    minWidth: 100,
                },
                //select row instead
                suppressCellSelection: true,
                maxWidth: 300,
            }


            this.columnDefs = [
                {
                    headerName: 'Number', field: 'projectNumber', width: 120,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        text.addEventListener('click', (e) => {
                            e.preventDefault
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    },
                    sort: "asc",
                    comparator: (a, b) => {
                        const numA = Number(a)
                        const numB = Number(b)

                        const isNumA = !isNaN(numA)
                        const isNumB = !isNaN(numB)

                        // both numeric → numeric sort
                        if (isNumA && isNumB) {
                            return numA - numB
                        }

                        // numeric comes before text
                        if (isNumA && !isNumB) return -1
                        if (!isNumA && isNumB) return 1

                        // both text → alphabetical
                        return String(a).localeCompare(String(b))
                    }
                },
                {
                    headerName: 'Name', field: 'projectName',
                    //manually binding event to each cell as rowclick is getting auto triggered
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        text.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    },
                    filter: 'agTextColumnFilter'
                },
                {
                    headerName: 'PI Name', field: 'projectManagers', width: 300,
                    valueGetter: (params) => {
                        // set value that is used for sorting
                        return params.data.projectManagers.map(x => x.displayName).join(', ')
                    },
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.data.projectManagers.map(x => x.displayName).join(', ');

                        text.addEventListener('click', (e) => {
                            e.preventDefault
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        console.log(params);
                        return text;
                    },
                    filter: 'agTextColumnFilter'
                },
                {
                    headerName: 'Start Date', field: 'startDate', width: 160,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value ? (new Date(params.value)).toLocaleDateString() : '';
                        text.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    },
                    valueFormatter: function (data) {
                        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
                    },
                    filter: 'agDateColumnFilter'
                },
                {
                    headerName: 'End Date', field: 'endDate', width: 160,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value ? (new Date(params.value)).toLocaleDateString() : '';
                        text.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    },
                    filter: 'agDateColumnFilter'
                },
                {
                    headerName: 'Archived', field: 'archived', width: 140,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        text.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    },
                    filter: 'agTextColumnFilter'
                }
            ];

            //TODO: refactor into enterprise http client
            axios
                .get(this.$hostname + 'projects', {
                    headers: {
                        "Authorization": "Bearer " + this.msal.accessToken
                    }
                })
                .then(response => {
                    this.rowData = response.data
                })
                .catch(error => {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: error
                    });
                    this.errored = true
                })
                .finally(() => this.loading = false)

        },
        mounted() {

        },
        methods: {
            onGridReady(params) {
                this.gridApi = params.api;
            },
            onFirstDataRendered() {
                this.gridApi.setFilterModel(this.archivedFilterModel)
            },
            toggleArchived() {
                if (!this.gridApi) {
                    return;
                }

                if (this.archiveFilter) {
                    this.gridApi.setFilterModel(null)
                } else {
                    this.gridApi.setFilterModel(this.archivedFilterModel)
                }

                this.archiveFilter = !this.archiveFilter
            }
        }
    }
</script>